import { toast } from "react-toastify";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { getSpdrBidPack } from "./GetSpdrBidPack";

export async function getLtlWithFetchedBidpack(
  ltlPipeline: LtlPipelineViewModel,
  startDateDisplay: string | undefined
) {
  const myLtlPipeline = { ...ltlPipeline };
  let ltlBidpack;

  try {
    ltlBidpack = await getSpdrBidPack(ltlPipeline, startDateDisplay);
  } catch (error: any) {
    const { SupplierGsdb, PlantGsdb } = ltlPipeline;
    let message = error.response.data.title;

    if (myLtlPipeline.SpdrId) {
      message += ` for SPR ${SupplierGsdb}-${PlantGsdb}`;
    }
    if (myLtlPipeline.PdsrId) {
      message += ` for PSR ${PlantGsdb}-${SupplierGsdb}`;
    }
    toast.error(message);
  }

  myLtlPipeline.isBidpackLoaded = true;
  myLtlPipeline.LtlBidpack = ltlBidpack;
  myLtlPipeline.CurrentDestinationName = ltlBidpack?.DestinationName;
  return myLtlPipeline;
}
